// Resolve the current draft after the asynchronous file copy, never the draft
// captured before opening the picker. This keeps Done/navigation from dropping the image.
export async function applyPickedMedia<Picked, Media, Document>(
  pick: () => Promise<Picked | null>,
  save: (picked: Picked) => Promise<Media>,
  current: () => Document | undefined,
  apply: (document: Document, media: Media) => void,
): Promise<void> {
  const picked = await pick();
  if (!picked) return;
  const media = await save(picked);
  const document = current();
  if (document) apply(document, media);
}
